import { useEffect, useState } from 'react';
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { ScrollArea } from '@/components/ui/scroll-area';
import { Capacitor } from '@capacitor/core';
import { App } from '@capacitor/app';
// Import the root release notes markdown as raw text (Vite)
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore - Vite provides string typings for ?raw
import releaseNotes from '../../APP_STORE_METADATA.md?raw';

export default function AppInfo() {
  const [open, setOpen] = useState(false);
  const [version, setVersion] = useState<string | null>(null);
  const [build, setBuild] = useState<string | number | null>(null);

  useEffect(() => {
    const load = async () => {
      try {
        if (Capacitor.isNativePlatform()) {
          const info = await App.getInfo();
          setVersion(info.version ?? null);
          setBuild(info.build ?? null);
          return;
        }
      } catch {}
      // Fallback for web
      const v = (import.meta.env.VITE_APP_VERSION as string | undefined) || null;
      setVersion(v);
    };
    load();
  }, []);

  const prettyVersion = version ? (build ? `${version} (${build})` : version) : 'dev';

  return (
    <Card>
      <CardHeader>
        <CardTitle>About imata</CardTitle>
        <CardDescription>Version and recent changes</CardDescription>
      </CardHeader>
      <CardContent className="space-y-3">
        <div className="text-sm text-muted-foreground">
          <span className="font-medium text-foreground">Version:</span> {prettyVersion}
        </div>
        <Button variant="outline" onClick={() => setOpen(true)}>
          View Release Notes
        </Button>
        <Dialog open={open} onOpenChange={setOpen}>
          <DialogContent className="sm:max-w-2xl">
            <DialogHeader>
              <DialogTitle>Release Notes</DialogTitle>
            </DialogHeader>
            <ScrollArea className="max-h-[60vh]">
              <pre className="whitespace-pre-wrap text-sm leading-6">
                {releaseNotes}
              </pre>
            </ScrollArea>
          </DialogContent>
        </Dialog>
      </CardContent>
    </Card>
  );
}
